"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var idlUtils = require("../generated/utils");

var ErrorEvent = require("../generated/ErrorEvent");

var EventHandlerNonNull = require("../generated/EventHandlerNonNull.js");

var OnBeforeUnloadEventHandlerNonNull = require("../generated/OnBeforeUnloadEventHandlerNonNull.js");

var OnErrorEventHandlerNonNull = require("../generated/OnErrorEventHandlerNonNull.js");

var reportException = require("./runtime-script-errors");

exports.appendHandler = function (el, eventName) {
  // tryImplForWrapper() is currently required due to use in Window.js
  idlUtils.tryImplForWrapper(el).addEventListener(eventName, function (event) {
    // https://html.spec.whatwg.org/#the-event-handler-processing-algorithm
    var callback = exports.getCurrentEventHandlerValue(el, eventName);

    if (callback === null) {
      return;
    }

    var specialError = ErrorEvent.isImpl(event) && event.type === "error" && event.currentTarget.constructor.name === "Window";
    var returnValue = null; // https://heycam.github.io/webidl/#es-invoking-callback-functions

    if (typeof callback === "function") {
      if (specialError) {
        returnValue = callback.call(event.currentTarget, event.message, event.filename, event.lineno, event.colno, event.error);
      } else {
        returnValue = callback.call(event.currentTarget, event);
      }
    } // TODO: we don't implement BeforeUnloadEvent so we can't brand-check here


    if (event.type === "beforeunload") {
      if (returnValue !== null) {
        event._canceledFlag = true;

        if (event.returnValue === "") {
          event.returnValue = returnValue;
        }
      }
    } else if (specialError) {
      if (returnValue === true) {
        event._canceledFlag = true;
      }
    } else if (returnValue === false) {
      event._canceledFlag = true;
    }
  });
}; // "Simple" in this case means "no content attributes involved"


exports.setupForSimpleEventAccessors = function (prototype, events) {
  prototype._getEventHandlerFor = function (event) {
    return this._eventHandlers ? this._eventHandlers[event] : undefined;
  };

  prototype._setEventHandlerFor = function (event, handler) {
    if (!this._registeredHandlers) {
      this._registeredHandlers = new Set();
      this._eventHandlers = Object.create(null);
    }

    if (!this._registeredHandlers.has(event) && handler !== null) {
      this._registeredHandlers.add(event);

      exports.appendHandler(this, event);
    }

    this._eventHandlers[event] = handler;
  };

  var _iterator = _createForOfIteratorHelper(events),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var event = _step.value;
      exports.createEventAccessor(prototype, event);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}; // https://html.spec.whatwg.org/multipage/webappapis.html#getting-the-current-value-of-the-event-handler


exports.getCurrentEventHandlerValue = function (target, event) {
  var value = target._getEventHandlerFor(event);

  if (!value) {
    return null;
  }

  if (value.body !== undefined) {
    var element, document, fn;

    if (target.constructor.name === "Window") {
      element = null;
      document = idlUtils.implForWrapper(target.document);
    } else {
      element = target;
      document = element.ownerDocument;
    }

    var body = value.body;
    var formOwner = element !== null && element.form ? element.form : null;
    var window = target.constructor.name === "Window" && target._document ? target : document.defaultView;

    try {
      // eslint-disable-next-line no-new-func
      Function(body); // properly error out on syntax errors
      // Note: this won't execute body; that would require `Function(body)()`.
    } catch (e) {
      if (window) {
        reportException(window, e);
      }

      target._setEventHandlerFor(event, null);

      return null;
    } // Note: the with (window) { } is not necessary in Node, but is necessary in a browserified environment.


    var createFunction = document.defaultView.Function;

    if (event === "error" && element === null) {
      var sourceURL = document ? "\n//# sourceURL=".concat(document.URL) : "";
      fn = createFunction("with (arguments[0]) { return function onerror(event, source, lineno, colno, error) {\n".concat(body, "\n}; }").concat(sourceURL))(window);
      fn = OnErrorEventHandlerNonNull.convert(fn);
    } else {
      var calls = [];

      if (element !== null) {
        calls.push(idlUtils.wrapperForImpl(document));
      }

      if (formOwner !== null) {
        calls.push(idlUtils.wrapperForImpl(formOwner));
      }

      if (element !== null) {
        calls.push(idlUtils.wrapperForImpl(element));
      }

      var wrapperBody = "with (arguments[0]) { return function on".concat(event, "(event) {\n").concat(body, "\n}; }"); // eslint-disable-next-line no-unused-vars

      for (var _i = 0, _calls = calls; _i < _calls.length; _i++) {
        var call = _calls[_i];
        wrapperBody = "with (arguments[0]) { return function () {\n".concat(wrapperBody, "\n}; }");
      }

      if (document) {
        wrapperBody += "\n//# sourceURL=".concat(document.URL);
      }

      fn = createFunction(wrapperBody)(window);

      for (var _i2 = 0, _calls2 = calls; _i2 < _calls2.length; _i2++) {
        var _call = _calls2[_i2];
        fn = fn(_call);
      }

      if (event === "beforeunload") {
        fn = OnBeforeUnloadEventHandlerNonNull.convert(fn);
      } else {
        fn = EventHandlerNonNull.convert(fn);
      }
    }

    target._setEventHandlerFor(event, fn);
  }

  return target._getEventHandlerFor(event);
}; // https://html.spec.whatwg.org/multipage/webappapis.html#event-handler-idl-attributes
// TODO: Consider replacing this with `[ReflectEvent]`


exports.createEventAccessor = function (obj, event) {
  Object.defineProperty(obj, "on" + event, {
    configurable: true,
    enumerable: true,
    get: function get() {
      return exports.getCurrentEventHandlerValue(this, event);
    },
    set: function set(val) {
      this._setEventHandlerFor(event, val);
    }
  });
};